import angular from 'angular';

const module = angular.module('whyline.modals.maximum-appointment-per-day-and-person', [
]);

const MaximumAppointmentPerDayAndPersonModalController = function (
  $uibModalInstance,
) {
  'ngInject'

  this.confirm = () => {
		$uibModalInstance.close('confirm');
	};

  this.cancel = () => {
		$uibModalInstance.close('cancel');
	};
};

module.exports = module.controller('MaximumAppointmentPerDayAndPersonModalController', MaximumAppointmentPerDayAndPersonModalController);
